import { gsap } from 'gsap';
import SplitType from 'split-type';
import { initHeader } from './components/header.js';
import { initScrollAnimations } from './components/animations.js';
import { initScrollToTop } from './components/scrollToTop.js';
import { initContactForm } from './components/contactForm.js';
import { initTestimonialCarousel } from './components/testimonialCarousel.js';
import { initClientCarousel } from './components/clientCarousel.js';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize header
  initHeader();
  
  // Initialize hero animations
  const heroTitle = new SplitType('.hero-title', { types: 'chars' });
  const tl = gsap.timeline();

  tl.from(heroTitle.chars, {
    opacity: 0,
    y: 50,
    rotateX: -90,
    stagger: 0.02,
    duration: 0.8,
    ease: 'back.out(1.7)'
  })
  .to('.hero-subtitle', {
    opacity: 1,
    y: 0,
    duration: 0.8,
    ease: 'power2.out'
  }, '-=0.4')
  .to('.hero-cta', {
    opacity: 1,
    y: 0,
    duration: 0.8,
    ease: 'power2.out'
  }, '-=0.4');
  
  // Initialize other components
  initScrollAnimations();
  initScrollToTop();
  initClientCarousel();
  
  const contactForm = document.querySelector('#contactForm');
  if (contactForm) {
    initContactForm(contactForm);
  }
  
  const testimonialCarousel = document.querySelector('.testimonial-carousel');
  if (testimonialCarousel) {
    initTestimonialCarousel(testimonialCarousel);
  }
});